import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyDataReportSelection = lazyWithRetry(
  () => import("./DataReportSelection"),
);

const DataReportSelection = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyDataReportSelection {...props} />;

export default DataReportSelection;
